import { useEffect as e } from "react";
var t = function (t) {
  var r = t.projectId,
    o = t.lang;
  return e(function () {
    if (r) {
      if (!document.querySelector('script[src*="https://app.upvoty.com"]')) {
        var e = document.createElement("script");
        return o && (e.lang = o), e.src = "https://app.upvoty.com/embed.js?id=" + r, e.defer = !0, e.addEventListener("error", function () {
          return e.remove();
        }), document.body.appendChild(e), function () {
          e.remove();
        };
      }
    } else console.error("No projectId was passed to Upvoty React, widget will not be initialized");
  }, [r, o]), null;
};
export { t as Upvoty };